<template>
  <div>
    <Message :show="message.msg" :message="message" />
    <div v-if="recordsData.length == 0" id="search-form">
      <div id="form">
        <form @submit.prevent="sendRequest">
          <label for="search-value">R.F.C. o texto a buscar</label>
          <input type="text" id="search-value" v-model="searchValue" placeholder="ABCD123456XYZ" autocomplete="off" v-uppercase>

          <button type="submit">BUSCAR</button>
        </form>
      </div>
    </div>
    <div v-if="searching">
        <div class="text-center d-flex justify-content-between">
            <h4>Buscando, por favor espere...</h4>
            <b-spinner
                :variant="dark"
                :key="dark"
                type="grow"
            ></b-spinner>
        </div>
    </div>
    <div v-if="recordsData.length > 0">
      <Result :records="recordsData" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { UpperCase } from '../directives/UpperCase';
import Message from './Message';
import Result from './Result';

export default {
  name: 'SearchForm',
  components: {
    Message,
    Result
  },
  directives: {
    UpperCase
  },
  data: function() {
    return {
      searchValue: '',
      recordsData: [],
      searching: false,
      variant: 'secondary',
      dark: 'dark',
      message: {}
    }
  },
  methods: {
    sendRequest: async function(object) {
      object.preventDefault();
      var vm = this;
      vm.message = {}

      if (vm.searchValue !== '' && vm.searchValue.length > 3) {
        // console.log(vm.searchValue);
        var url = process.env.VUE_APP_HOST + process.env.VUE_APP_PATH_API + 'search?query=' + vm.searchValue.toUpperCase();
        // console.log(url);
        const user = JSON.parse(Vue.localStorage.get('user'));
        if (user && user.access && user.access.key) {
          vm.searching = true;
          const axiosParams = {
            headers: {
              'Authorization': user.access.key
            }
          }
          await axios.get(url, axiosParams).then(async function(response) {
              vm.recordsData = Array(response.data);
              // console.log(vm.records);
              vm.searching = false;
              // console.log(vm.recordsData);
          }).catch(function(error) {
              vm.message = {
                msg: error,
                variant: 'danger',
                dismiss: 4
              }
              console.log(error);
              vm.searching = false;
          });
        } else {
          vm.message = {
            msg: "No existe clave para realizar peticiones",
            variant: 'danger',
            dismiss: 4
          }          
        }
      } else {
        vm.message = {
          msg: "RFC o Texto a buscar nulo o vacío",
          variant: 'warning',
          dismiss: 4
        } 
      }
    }
  }
}
</script>

<style lang="sass">
  @import '../assets/styles/_app.sass';
  @import '../assets/styles/_search.sass';
</style>